<script lang='ts'>
    import HelpIcon from './HelpIcon.svelte';

    let {
        class: xclass = '',
        value = $bindable(),
        disabled = false,
        onchange = function(value) {},
        id = null,
        maxlength = null,
        ondblclick = null,
        onkeydown = null,
        enablePreAnswer = false,
        preAnswer = '',
        placeholder = '',
        autofocus = false,
        help = undefined
    }: {
        class?: string;
        value?: string;
        disabled?: boolean;
        onchange?: (value: string) => void;
        id?: string | null;
        maxlength?: number | null;
        ondblclick?: ((event: MouseEvent) => void) | null;
        onkeydown?: ((event: KeyboardEvent) => void) | null;
        enablePreAnswer?: boolean;
        preAnswer?: string;
        placeholder?: string;
        autofocus?: boolean;
        help?: string;
    } = $props()

    $effect(() => {
        if (enablePreAnswer && preAnswer && (!value || value === '')) {
            value = preAnswer;
        }
    });

    function handleFocus(event: FocusEvent) {
        const target = event.target as HTMLInputElement;
        target.select();
    }
    function handleInputChange(event: Event) {
        const target = event.target as HTMLInputElement;
        let newValue = target.value;
        value = newValue;
        onchange?.(newValue);
    }

    function getDisabledClasses(disabledState: boolean) {
        return disabledState ? 'bg-slate-50 text-slate-500 border-slate-200 shadow-none' : ''
    }

    let disabledClasses = $derived(getDisabledClasses(disabled))
</script>

{#if help}
    <div class="input-with-help">
        <!-- svelte-ignore a11y_autofocus -->
        <input
            {disabled}
            {id}
            {maxlength}
            {ondblclick}
            {onkeydown}
            {placeholder}
            class="input-text {disabledClasses} {xclass}"
            type="text"
            inputmode="text"
            {autofocus}
            onfocus={handleFocus}
            onchange={handleInputChange}
            bind:value
        />
        <HelpIcon {help} />
    </div>
{:else}
    <!-- svelte-ignore a11y_autofocus -->
    <input
        {disabled}
        {id}
        {maxlength}
        {ondblclick}
        {onkeydown}
        {placeholder}
        class="input-text {disabledClasses} {xclass}"
        type="text"
        inputmode="text"
        {autofocus}
        onfocus={handleFocus}
        onchange={handleInputChange}
        bind:value
    />
{/if}

<style>
    .input-with-help {
        display: inline-flex;
        align-items: center;
        width: 100%;
    }

    .input-with-help .input-text {
        flex: 1;
    }

    .input-text {
        margin: 0;
        padding: 0 0.75rem 0 1rem;
        height: 2rem;
        border: 1px solid var(--color-primary);
        border-radius: 0.25rem;
        box-sizing: border-box;
    }

    .input-text:focus {
        border: none;
        outline: 2px solid var(--color-primary);
        outline-offset: 0;
    }

    .input-text:disabled {
        background-color: rgb(248 250 252); /* slate-50 */
        color: rgb(107 114 128); /* slate-500 */
        border-color: rgb(226 232 240); /* slate-200 */
        box-shadow: none;
    }
</style>
